import { Component, Input } from '@angular/core';
import { MaterialModule } from '@app/material.module';

@Component({
  selector: 'app-custom-title',
  imports: [MaterialModule],
  templateUrl: './custom-title.component.html',
  styleUrl: './custom-title.component.scss',
})
export class CustomTitleComponent {

  @Input() title!: string;
  @Input() icon!: string;

}
